import React from 'react';

const DragWrapper = (props) => {
    const { position, children } = props;
    return (React.createElement("div", { style: {
            position: 'fixed',
            left: `${position.x}px`,
            top: `${position.y}px`,
            zIndex: 99999,
        } }, children));
};

export { DragWrapper };
//# sourceMappingURL=drag-wrapper.js.map
